import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell, Field, FormError } from "../components/AuthShell";
import { api, errMsg } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { const { data } = await api.post("/auth/forgot-password", { email }); setMsg(data.message); }
    catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title="reset password" subtitle="we'll email you a one-time link." footer={<Link to="/login" className="text-[#ff3b91] hover:underline" data-testid="forgot-back-link">back to login</Link>}>
      {msg ? <div data-testid="forgot-success-message" className="rounded-xl border border-[#ff3b91]/30 bg-[#ff3b91]/10 px-4 py-3 text-sm text-pink-100">{msg}</div> : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="email" type="email" data-testid="forgot-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <FormError msg={err} />
          <button disabled={busy} className="btn-pink w-full" data-testid="forgot-submit-button">{busy ? "sending…" : "send reset link"}</button>
        </form>
      )}
    </AuthShell>
  );
}
